import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../../api.js';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';
import FleetFormModal from './FleetFormModal.jsx';

const TrashIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>;

export default function FleetList() {
  const [fleets, setFleets] = useState(null);
  const [query, setQuery] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  function load() {
    setFleets(null);
    api('/dispatch/fleets').then(setFleets).catch(() => setFleets([]));
  }

  const deleteFleet = async (e, f) => {
    e.stopPropagation();
    if (!window.confirm(`Delete "${f.name}"? Trucks and trailers in it will become unassigned, not deleted.`)) return;
    await api(`/dispatch/fleets/${f.id}`, { method: 'DELETE' });
    load();
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    if (!fleets) return [];
    const q = query.trim().toLowerCase();
    if (!q) return fleets;
    return fleets.filter(f => [f.name, f.ref_number, f.base_region, f.owner_contact_name].filter(Boolean).some(v => v.toLowerCase().includes(q)));
  }, [fleets, query]);

  return (
    <div>
      <PageHeader
        icon={Icon.control}
        title="Fleets"
        subtitle="Owner-operator fleets — grouped trucks and trailers by region"
        color={SECTION_COLOR.control}
        actions={<button className="primary-btn" onClick={() => { setEditing(null); setFormOpen(true); }}>+ New fleet</button>}
      />

      <div className="panel filter-row-panel">
        <div className="filter-row">
          <input placeholder="Type to filter..." value={query} onChange={e => setQuery(e.target.value)} style={{ width: 240 }} />
        </div>
      </div>

      {fleets === null && <div className="empty">Loading...</div>}
      {fleets && fleets.length === 0 && <div className="empty">No fleets yet — click "+ New fleet" above.</div>}

      {fleets && fleets.length > 0 && (
        <table>
          <thead>
            <tr><th>Ref#</th><th>Fleet Name</th><th>Owner Contact</th><th>Base Region</th><th>Trucks</th><th>Trailers</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {filtered.map(f => (
              <tr key={f.id} onClick={() => { setEditing(f); setFormOpen(true); }} style={{ cursor: 'pointer' }}>
                <td>{f.ref_number || '—'}</td>
                <td>{f.name}</td>
                <td>{f.owner_contact_name || '—'}</td>
                <td>{f.base_region || '—'}</td>
                <td>{f.truck_count}</td>
                <td>{f.trailer_count}</td>
                <td>{f.status || 'Active'}</td>
                <td>
                  <button type="button" title="Delete fleet" onClick={e => deleteFleet(e, f)}
                    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--red)', cursor: 'pointer', padding: 0 }}>
                    <TrashIcon />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {formOpen && (
        <FleetFormModal fleet={editing} onClose={() => setFormOpen(false)} onSaved={() => { setFormOpen(false); load(); }} />
      )}
    </div>
  );
}
